import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import {
  CreateLeadParams,
  CreateLeadResponse,
  LeadDetails,
  createLead,
  createLeadByUnlockContent,
} from '../utils/backend-api/user';

export default function useCreateLead(unlockContent: boolean, leadDetails: LeadDetails) {
  const submit = unlockContent ? createLeadByUnlockContent : createLead;
  const { mutate, mutateAsync, data, isLoading, isError } = useMutation(
    (params: CreateLeadParams) => submit(params, leadDetails),
    {
      onSuccess: (data: CreateLeadResponse) => {
        window.location.href = data.location;
      },
      onError: (error: { message: string }) => {
        toast.error(error.message);
      },
    }
  );
  return { mutate, mutateAsync, data, isLoading, isError };
}
